import { useEffect, useState } from "react";

import { FcGoogle } from "react-icons/fc";
import { useNavigate } from "react-router-dom";
import styled, { ThemeProvider } from "styled-components";

import { getUserInfo } from "shared/api/AuthApi";
import { theme } from "styles/theme";

function LoginPageWeb() {
  const navigate = useNavigate();
  const [isCheckingLogin, setIsCheckingLogin] = useState(true);
  const clientId = process.env.REACT_APP_GOOGLE_CLIENT_ID;
  // redirect_uri는 현재 접속한 origin에서 자동 생성한다.
  // 배포 도메인(stu-ad.web.app, stu.handong.edu)과 로컬 모두 접속 주소에 맞게 결정된다.
  const redirectUri = `${window.location.origin}/login/oauth/google`;

  const googleAuthUrl = `https://accounts.google.com/o/oauth2/v2/auth?${new URLSearchParams(
    {
      scope:
        "https://www.googleapis.com/auth/userinfo.profile https://www.googleapis.com/auth/userinfo.email",
      client_id: clientId || "",
      response_type: "code",
      redirect_uri: redirectUri,
      access_type: "offline",
    },
  ).toString()}`;

  useEffect(() => {
    let isMounted = true;
    const token = localStorage.getItem("admintoken");

    const verifyLogin = async () => {
      if (!token) {
        if (isMounted) {
          setIsCheckingLogin(false);
        }
        return;
      }

      try {
        await getUserInfo();
        if (isMounted) {
          navigate("/", { replace: true });
        }
      } catch (error) {
        localStorage.removeItem("admintoken");
        if (isMounted) {
          setIsCheckingLogin(false);
        }
      }
    };

    verifyLogin();

    return () => {
      isMounted = false;
    };
  }, [navigate]);

  return (
    <>
      <Div>
        <PartDiv>
          <ThemeProvider theme={theme}>
            <AdminTitle>ADMIN</AdminTitle>
            <HandongLogo
              src={require("assets/Img/Login/HGUTextLogo.png")}
              alt="Handong Logo"
            />
            <a
              href={googleAuthUrl}
              style={{ textDecoration: "none" }}
              onClick={(event) => {
                if (isCheckingLogin) {
                  event.preventDefault();
                }
              }}
            >
              <GoogleLoginButton disabled={isCheckingLogin}>
                <GoogleLogo as={FcGoogle} />
                <Header2>
                  {isCheckingLogin
                    ? "로그인 상태 확인 중..."
                    : "구글로 로그인하기"}
                </Header2>
              </GoogleLoginButton>
            </a>
            <Caption1>
              * handong.edu / handong.ac.kr로만 로그인이 가능합니다. <br />그 외
              로그인이 필요하신 경우 아래 메일로 문의 주세요.
            </Caption1>
            <CaptionA
              href="https://stu.handong.edu/terms.html"
              target="_blank"
              rel="noreferrer"
            >
              이용약관 동의서
            </CaptionA>
            <Caption>
              로그인 시 이용약관에 동의한 것으로 간주되며 <br />
              자세한 사항은 상단의 이용약관 동의서를 참고해주시기 바랍니다.
            </Caption>
            <Body4 $top={40}>
              문의 : 한동대학교 제31대 총학생회 중앙집행위원회 'FLOW
              '(flowhgu.student@gmail.com)
            </Body4>
            <Body4 $top={16}>
              37554 경북 포항시 북구 흥해읍 한동로 558 한동대학교
              <br />
              Tel: 054-260-1111 Fax: 054-260-1149
              <br />
              Copyright 2024. HANDONG GLOBAL UNIVERSITY All Rights Reserved.
            </Body4>
          </ThemeProvider>
        </PartDiv>
      </Div>
    </>
  );
}

export default LoginPageWeb;

const Caption1 = styled.div`
  font-size: ${(props) => props.theme.Web_fontSizes.Caption1};
  font-weight: ${(props) => props.theme.fontWeights.Caption1};
  line-height: ${(props) => props.theme.LineHeight.Caption1};
  font-family: "Pretendard";
  text-decoration: none;
  color: #9c9c9c;
  margin-top: 12px;
  text-align: center;
`;

const Caption = styled.div`
  font-size: ${(props) => props.theme.Web_fontSizes.Caption1};
  font-weight: ${(props) => props.theme.fontWeights.Caption1};
  line-height: ${(props) => props.theme.LineHeight.Caption1};
  font-family: "Pretendard";
  text-decoration: none;
  color: #9c9c9c;
  margin-top: 2px;
  text-align: center;
`;

const CaptionA = styled.a`
  font-size: ${(props) => props.theme.Web_fontSizes.Caption1};
  font-weight: ${(props) => props.theme.fontWeights.Caption1};
  line-height: ${(props) => props.theme.LineHeight.Caption1};
  font-family: "Pretendard";
  text-decoration-line: underline;
  color: #9c9c9c;
  margin-top: 12px;
  text-align: center;
  cursor: pointer;
`;

const Body4 = styled.div`
  font-size: ${(props) => props.theme.Web_fontSizes.Body4};
  font-weight: ${(props) => props.theme.fontWeights.Body4};
  line-height: ${(props) => props.theme.LineHeight.Body4};
  font-family: "Pretendard";
  text-decoration: none;
  text-align: center;
  color: #9c9c9c;
  margin-top: ${(props) => props.$top}px;
`;

const Header2 = styled.div`
  font-size: ${(props) => props.theme.Web_fontSizes.Header2};
  font-weight: ${(props) => props.theme.fontWeights.Header2};
  line-height: ${(props) => props.theme.LineHeight.Header2};
  font-family: "Pretendard";
  text-decoration: none;
  text-align: center;
  color: white;
`;

const PartDiv = styled.div`
  height: 100vh;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  width: 100%;
  margin: 0 auto;
  background-color: #f4faff;
`;
const Div = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin: 0 auto;
  width: 100%;
  z-index: 999px;
  position: fixed;
`;

const GoogleLoginButton = styled.button`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 10px;
  gap: 10px;
  margin-top: 40px;
  width: 460px;
  height: 64px;
  background: #3756a4;
  border-radius: 8px;
  flex: none;
  order: 0;
  flex-grow: 0;
  border: none;
  cursor: pointer;

  &:disabled {
    opacity: 0.7;
    cursor: not-allowed;
  }
`;

const GoogleLogo = styled.img`
  width: 24px;
  height: 24px;
`;

const HandongLogo = styled.img`
  width: 270px;
  height: 82px;
`;

const AdminTitle = styled.div`
  font-family: "Pretendard";
  font-weight: 700;
  font-style: normal;
  font-size: 32px;
  leading-trim: none;
  line-height: 140%;
  letter-spacing: 0;
  text-align: center;
  margin-bottom: -20px;
`;
